import { api } from './client';

export function listTags() {
  return api<string[]>('/tags');
}
